module.exports = __webpack_public_path__ + "resources/img/img_hi_psm_jp.132b93af56e597128f36ae2abd5713f8.png";